import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-de698d2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile_contents_wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "profile_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "profile_title_text" }, "パスワードの編集")
], -1))
const _hoisted_3 = { class: "profile_input" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "現在のパスワード"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須")
], -1))
const _hoisted_5 = { class: "profile_input_layout_column_1" }
const _hoisted_6 = { class: "profile_input_layout_column_1_item" }
const _hoisted_7 = { class: "profile_password_forgot" }
const _hoisted_8 = { class: "profile_input" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "新しいパスワード"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須")
], -1))
const _hoisted_10 = { class: "profile_input_layout_column_1" }
const _hoisted_11 = { class: "profile_input_layout_column_1_item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "profile_text_list" }, "パスワードは半角英数字6文字以上12文字以内のアルファベットと数字を各1文字以上を使用してください", -1))
const _hoisted_13 = { class: "profile_input" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "新しいパスワード（再入力）"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須")
], -1))
const _hoisted_15 = { class: "profile_input_layout_column_1" }
const _hoisted_16 = { class: "profile_input_layout_column_1_item" }
const _hoisted_17 = { class: "profile_button" }
const _hoisted_18 = { class: "profile_button_prev" }
const _hoisted_19 = { class: "profile_button_next" }

import BasePasswordForm from '@/components/BasePasswordForm.vue';
import BaseButton from '@/components/BaseButton.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';
import { ref, Ref, watch } from 'vue';
import Loading from '@/components/Loading.vue';
import { postPasswordEdit } from '@/api/careersheetEndpoint';
import { useRouter, useRoute } from 'vue-router';
import { useField, useForm } from 'vee-validate';
import { validationRuleHelper } from '@/utils/validationRule';
import store from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordEditView',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const isLoading = ref(false);
const { meta } = useForm();

const { value: password, errors: passwordErrors } = useField<string>(
  'password',
  validationRuleHelper({ required: true, min: 6, max: 12, password: true }),
  {
    initialValue: '',
    bails: false,
    label: 'パスワード',
  }
);

const wrongPasswordError: Ref<string[]> = ref([]);
watch(password, () => {
  wrongPasswordError.value = [];
});

const { value: newPassword, errors: newPasswordErrors } = useField<string>(
  'newPassword',
  validationRuleHelper({ required: true, min: 6, max: 12, password: true, not_same: '@password' }),
  {
    initialValue: '',
    bails: false,
    label: '新しいパスワード',
  }
);

const { value: newConfirmPassword, errors: newConfirmPasswordErrors } = useField<string>(
  'newConfirmPassword',
  validationRuleHelper({ required: true, confirmation: '@newPassword' }),
  {
    initialValue: '',
    bails: false,
    label: '新しいパスワード（再入力）',
  }
);

const transitionPreviousPage = () => {
  if (route.query.ref === 'e') {
    router.push({ name: 'e20', query: { ref: 'e' } });
  } else {
    router.push({ name: 'n20' });
  }
};

const updatePassword = async () => {
  isLoading.value = true;
  try {
    await postPasswordEdit({
      password: password.value,
      newPassword: newPassword.value,
    });
    store.dispatch('toasts/appendTimeToast', { label: 'パスワードを更新しました' });
    if (route.query.ref === 'e') {
      router.push({ name: 'e20', query: { ref: 'e' } });
    } else {
      router.push({ name: 'n20' });
    }
  } catch (error) {
    console.error(error);
    wrongPasswordError.value =
      (error as { response: { data: { errorDetail: { globalError: { args: string[] }[] } } } }).response.data.errorDetail.globalError[0]
        .args || [];
    store.dispatch('toasts/appendTimeToast', { label: 'パスワードの更新に失敗しました', duration: null });
  } finally {
    isLoading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(BasePasswordForm, {
              modelValue: _unref(password),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(password) ? (password).value = $event : null)),
              isError: _unref(passwordErrors).length > 0 || wrongPasswordError.value.length > 0,
              autocomplete: "off"
            }, null, 8, ["modelValue", "isError"])
          ])
        ]),
        _createVNode(ErrorMessage, { errors: _unref(passwordErrors) }, null, 8, ["errors"]),
        (!!wrongPasswordError.value)
          ? (_openBlock(), _createBlock(ErrorMessage, {
              key: 0,
              errors: wrongPasswordError.value
            }, null, 8, ["errors"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_RouterLink, {
            class: "text_link",
            to: { name: 'a20' }
          }, {
            default: _withCtx(() => [
              _createTextVNode("パスワードをお忘れの方")
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(BasePasswordForm, {
              modelValue: _unref(newPassword),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(newPassword) ? (newPassword).value = $event : null)),
              isError: _unref(newPasswordErrors).length > 0,
              autocomplete: "off"
            }, null, 8, ["modelValue", "isError"])
          ])
        ])
      ]),
      _createVNode(ErrorMessage, { errors: _unref(newPasswordErrors) }, null, 8, ["errors"]),
      _hoisted_12,
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createVNode(BasePasswordForm, {
              modelValue: _unref(newConfirmPassword),
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(newConfirmPassword) ? (newConfirmPassword).value = $event : null)),
              isError: _unref(newConfirmPasswordErrors).length > 0
            }, null, 8, ["modelValue", "isError"])
          ])
        ])
      ]),
      _createVNode(ErrorMessage, { errors: _unref(newConfirmPasswordErrors) }, null, 8, ["errors"]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createVNode(BaseButton, {
            theme: "tertiary",
            type: "button",
            onClick: transitionPreviousPage
          }, {
            default: _withCtx(() => [
              _createTextVNode("戻る")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(BaseButton, {
            theme: "primary",
            type: "button",
            onClick: updatePassword,
            disabled: !_unref(meta).valid
          }, {
            default: _withCtx(() => [
              _createTextVNode("変更する")
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ])
  ]))
}
}

})